import { render, staticRenderFns } from "./ProductFacetFilterDesktop.vue?vue&type=template&id=232c1198"
import script from "./ProductFacetFilterDesktop.vue?vue&type=script&lang=js"
export * from "./ProductFacetFilterDesktop.vue?vue&type=script&lang=js"
import style0 from "./ProductFacetFilterDesktop.vue?vue&type=style&index=0&id=232c1198&prod&global=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports